import * as React from "react";

export const IconActionDelete = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_30936_9195)">
      <path
        d="M5.00002 15.8333C5.00002 16.75 5.75002 17.5 6.66669 17.5H13.3334C14.25 17.5 15 16.75 15 15.8333L15 5.83333L5.00002 5.83333L5.00002 15.8333ZM15.8334 3.33333L12.9167 3.33333L12.0834 2.5L7.91669 2.5L7.08335 3.33333L4.16669 3.33333V5L15.8334 5V3.33333Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_30936_9195">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
